import React, { memo } from "react";

import Button from "./Button";
import Icon from "../../assets/icons/Icon";

const SubHeading = ({
  subTitle = "",
  isAddBtn = false,
  handleClick,
  handleFilterFlag,
  isFilterToggle = false,
}) => {
  return (
    <>
      <div className="hading-box ">
        <p className="text-box">{subTitle}</p>

        {isAddBtn && (
          <Button
            type="button"
            className="add_btn"
            title="View"
            onClick={() =>
              handleClick({
                rowData: {},
                modalName: "user_add",
                modalTitle: "Create User",
              })
            }
          >
            <Icon name="FaPlus" /> Add
          </Button>
        )}

        {isFilterToggle && (
          <Button
            type="button"
            className="add_btn column-gap-1"
            title="Toggle Filter"
            onClick={handleFilterFlag}
          >
            <Icon name="FaFilter" />
            Filter
          </Button>
        )}
      </div>
    </>
  );
};

export default memo(SubHeading);
